import { WhatsappService } from '@/services/whatsapp.service';
import { queryOptions } from '@tanstack/react-query';

export const listWhatsappConnectionQuery = queryOptions({
  queryKey: ['list-whatsapp-connections'],
  queryFn: WhatsappService.list,
});